
var sc = sc || {};
sc.alpine = sc.alpine || {};

sc.alpine.preventDoubleClick = function () {
    return {
        timestamp: 0,
        delay: 2000,
        trigger: {
            ['x-on:click'](event) {
                if (this.timestamp + this.delay > event.timeStamp) {
                    // double-click - cancel follow
                    event.preventDefault();
                    return
                }
                // follow link
                this.timestamp = event.timeStamp;
            },
        }
    }
}